'use client';
import { Box, Text } from '@/components';
import { useTranslation } from '@/hooks';

const NoPromotion: React.FC<{ title: string }> = ({ title }) => {
  const { t } = useTranslation('pages.promotion');
  return (
    <>
      <Box display="flex" justifyContent="center" paddingBlock={'100px'}>
        <Text fontWeight="bold">{t(title)}</Text>
      </Box>
    </>
  );
};
export default NoPromotion;
